module.exports = __webpack_public_path__ + "fonts/EuclidSquare-Regular.woff2";